import { StackActions } from '../../native/bridge/ReactNavigation';
import FCM, { FCMEvent } from '../../native/bridge/ReactNativeFCM';
import DeviceInfo from '../../native/bridge/ReactNativeDeviceInfo';
import Resource from '../../resource/Resource';
import { PUSHNOTIFICATION_START, UPDATE_FCM_TOKEN } from './actions';
import {
  stackAction,
  jumpToIndex,
} from '../../native/bridge/NavigationService';

import { navigateToPostDetailsFromNotification } from '../Notifications/dispatchers';

export function switchToNotificationTab() {
  return () => {
    jumpToIndex(0);
  };
}

export function onActionViewPostDetail(notification) {
  return (dispatch) => {
    dispatch(stackAction(StackActions.POP));
    setTimeout(() => {
      // 2nd param: isFromPushNotification
      dispatch(navigateToPostDetailsFromNotification(notification, true));
    }, 500);
  };
}

export function showLocalNotification(notif) {
  // return Promise.resolve();
  FCM.presentLocalNotification({
    channel: 'default',
    body: notif.getIn(['fcm', 'body']),
    priority: 'high',
    icon: 'icon',
    sound: 'default',
    show_in_foreground: true,
    subscription: notif.get('subscription'),
    summary: notif.get('summary'),
  });
}

export function updateFCMTokenToServer(uniqueId, token, clearToken = false) {
  return (dispatch) => {
    // return Promise.resolve();
    // get the list of token for user in backend, if not exist, create, if exist update
    return Resource.lookup('firebase', 'listInstanceKeyMappings').then(
      (result) => {
        if (result.length > 0 || !!clearToken) {
          return Resource.execute('firebase', 'addOrUpdateInstanceToken', {
            deviceId: uniqueId,
            instanceToken: token,
          }).then(() => {
            dispatch({
              type: UPDATE_FCM_TOKEN,
              token,
            });
          });
        } else {
          const formData = {};
          formData.deviceId = uniqueId;
          formData.instanceToken = token;
          return Resource.create('firebase', formData).then(() => {
            dispatch({
              type: UPDATE_FCM_TOKEN,
              token,
            });
          });
        }
      }
    );
  };
}

export function registerPushNotificationToken() {
  return (dispatch) => {
    // return Promise.resolve();
    dispatch({
      type: PUSHNOTIFICATION_START,
    });

    const uniqueId = DeviceInfo.getUniqueID();
    FCM.requestPermissions();

    FCM.getFCMToken().then((token) => {
      dispatch(updateFCMTokenToServer(uniqueId, token));
    });

    FCM.on(FCMEvent.RefreshToken, (token) => {
      dispatch(updateFCMTokenToServer(uniqueId, token));
    });
  };
}

export function clearFCMTokenFromServer() {
  return (dispatch) => {
    // return Promise.resolve();
    const uniqueId = DeviceInfo.getUniqueID();
    return dispatch(updateFCMTokenToServer(uniqueId, '', true));
  };
}
